var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.35 98.5",
    id: "svg6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "use887"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 8.6419048,12.61041 c 0,-4.0875774 4.1033422,-3.8463771 4.9276482,-3.8463771 11.972724,0.1510269 20.187063,0.1667095 32.162448,0.035382 0.778399,0 1.017907,1.191801 1.011919,4.9247931 -0.02794,23.271289 -0.03124,46.539294 -0.0099,69.804017 0,3.32916 -0.129734,4.924793 -0.902147,4.924793 -12.119089,-0.0985 -33.093756,-0.02788 -33.093756,-0.02788 -0.32448,-0.01079 -3.978117,-0.43505 -4.0824907,-3.102378 0,0 0.060992,-47.611884 -0.013721,-72.71235 z",
    fill: "#f1f4f4",
    id: "path898",
    style: {
      fill: "#00ff00",
      fillOpacity: 1,
      strokeWidth: 0.443382
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.8502647,86.282006 c 0,4.087577 4.103342,3.846377 4.927648,3.846377 11.9727243,-0.151027 20.1870633,-0.16671 32.1624483,-0.03538 0.778399,0 1.017907,-1.191801 1.011919,-4.924793 -0.02794,-23.271289 -0.03124,-46.539294 -0.0099,-69.804017 0,-3.32916 -0.129734,-4.924793 -0.902147,-4.924793 -12.119089,0.0985 -33.0937563,0.02788 -33.0937563,0.02788 -0.32448,0.01079 -3.9781173,0.43505 -4.082491,3.102378 0,0 0.06099,47.611884 -0.01372,72.71235 z",
    fill: "#f1f4f4",
    id: "path900",
    style: {
      fill: "#00ff00",
      fillOpacity: 1,
      strokeWidth: 0.443382
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 207.89,69.32 v 16.73 c -0.07,8.51 -4,12.44 -12.56,12.44 H 12.66 C 3.61,98.5 0,94.94 0,85.86 V 12.23 C 0,4.05 4,0 12.18,0 H 195.4 c 8.34,0 12.34,4.06 12.5,12.58 0.08,4.42 0.15,8.86 -0.1,13.27 -0.19,3.47 1.5,5.1 4.53,4.55 5.32,-1 6.63,2.53 6.79,6.23 0.36,8.47 0.24,17 0,25.45 -0.1,4 -2.33,6.48 -6.55,6.79 -1.39,0.13 -2.81,0.28 -4.68,0.45 z M 10.443306,88.482605 C 12.193306,88.692605 11.41,89.61 12.3,89.61 c 60.72,0 121.44,0.03 182.16,0.09 3.87,0 4.54,-1.6 4.52,-5 -0.0933,-23.62 -0.0767,-47.243333 0.05,-70.87 0,-3.84 -1.17,-5 -5.07,-5 C 133.98667,8.9433333 74,8.93 14,8.79 c -4.13,0 -5.39,1.15 -5.34,5.3 0.21,17 0.08,34 0.08,50.93 z",
    fill: "#10243c",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.8502657,86.282008 8.76,65 C 8.6878967,48.000153 8.89,31 8.68,14.07 8.68,9.92 9.89,8.77 14.02,8.77 74.006667,8.9233333 134,8.9333333 194,8.8 c 3.9,0 5.1,1.21 5.07,5 -0.14,23.626667 -0.15667,47.25 -0.05,70.87 0,3.38 -0.65,5 -4.52,5 C 133.78,89.57 73.675482,89.62732 12.955482,89.66732 10.173318,90.001873 8.6103842,88.976221 8.8502657,86.282008 Z",
    fill: "#f1f4f4",
    id: "path4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 7.959007,12.360565 c 0,-4.1686475 4.064613,-3.9226637 4.881138,-3.9226637 L 45.825144,8.7426555 45.959007,89.65879 12.462775,89.72814 c -2.7504517,0.01635 -3.6075945,0.0248 -3.6874611,-2.979268 0,0 -0.7423015,-48.790011 -0.8163069,-74.388307 z",
    fill: "#f1f4f4",
    id: "path4-3",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.445639
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.825144,8.7426555 c 0,0 29.039606,0.147934 37.945615,0.051403 l -0.16559,80.7276405 -37.83441,0.05072 z",
    fill: "#f1f4f4",
    id: "path4-3-7",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.447546
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.770759,8.7940585 c 0,0 29.039601,0.147934 37.945611,0.051403 l -0.16559,80.7276405 -37.834406,0.05072 z",
    fill: "#f1f4f4",
    id: "path4-3-7-5",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.447546
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.7178,8.8454615 c 0,0 29.80381,0.147934 38.94419,0.0514 l -0.16996,80.7276395 -38.83004,0.0507 z",
    fill: "#f1f4f4",
    id: "path4-3-7-3",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.453397
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 199.196,12.326272 c 0,-4.1686483 -4.17158,-3.9226643 -5.0096,-3.9226643 l -33.85302,0.304754 -0.13738,80.9161393 34.37771,0.0694 c 2.82285,0.0164 4.3606,-0.675304 4.44256,-3.679374 0,0 0.10379,-48.089909 0.17973,-73.688205 z",
    fill: "#f1f4f4",
    id: "path4-3-5",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.451464
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.575855b66a3a2f44eeb2bf175e7836da.svg";
export { ForwardRef as ReactComponent };